export default __webpack_public_path__ + "static/media/line_graph.2e94a8d1.svg";